import React, { Component } from "react";
import { Row, Col } from "reactstrap";
import { eventService } from "./services/Event.service";
import EventTable from "./EventTable";
import EventForm from "./EventForm";
import { toast } from "react-toastify";
import ConfirmationModal from "../../Shared/ConfirmationModal";
import { dateTimeutils } from "../../../_utils";

const initialFetchingState = {
  fetching: false,
  fetched: false,
  events: null,
  error: null,
  filterParams: null,
  pages: null,
  pageNum: 0,
  pageSize: 10
};

const initialSubmitState = {
  submitting: false,
  submitted: false,
  formResponse: null,
  formError: null,
  hasParams: false,
  isView: false
};

const initailGetState = {
  fetchingEvent: false,
  fetchedEvent: false,
  selectedRow: null
};

const initailDeleteState = {
  deletingEvent: false,
  deletedEvent: false,
  deleteError: null,
  deleteResponse: null
};

class ManageEvents extends Component {
  state = {
    ...initialFetchingState,
    ...initialSubmitState,
    ...initailGetState,
    ...initailDeleteState,
    showNextJoyRide: false,
    showJoyRideOnTable: false
  };

  componentDidMount() {
    const { pageNum, pageSize } = this.state;
    this.getEvents({ pageNum: pageNum + 1, pageSize });
    if (this.props.location.state) {
      const { run } = this.props.location.state;

      if (run) {
        this.setState({ showNextJoyRide: run });
      } else {
        return;
      }
    }
  }

  getEvents = async params => {
    this.setState({
      ...this.state,
      fetching: true
    });
    try {
      let response = await eventService.getAllEvents(params);
      if (response) {
        const validateEvent = response.content.map(event => {
          const secondstoGo = this.eventHasPassed(event.startDate, new Date());
          secondstoGo > 0
            ? (event.hasPassed = false)
            : (event.hasPassed = true);
          return event;
        });

        response.content = validateEvent;
        this.setState({
          ...this.state,
          fetching: false,
          fetched: true,
          events: response,
          pages: Math.ceil(response.count / params.pageSize),
          error: null
        });
      }
    } catch (error) {
      this.setState({
        ...this.state,
        fetching: false,
        fetched: false,
        error
      });
    }
  };

  addEvent = async requestBody => {
    const { pageSize, selectedRow } = this.state;

    this.setState({
      ...this.state,
      submitting: true,
      submitted: false,
      formResponse: null,
      formError: null
    });
    try {
      let response = await eventService.addEvent(
        requestBody,
        selectedRow && selectedRow.id
      );
      if (response) {
        this.setState({
          ...this.state,
          submitting: false,
          submitted: true,
          formResponse: response,
          formError: null
        });
        this.getEvents({ pageNum: 1, pageSize });
        toast.success(
          `Event ${selectedRow ? "updated" : "created"} successfully`,
          {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 4000
          }
        );
        selectedRow && this.resetButton();
      }
    } catch (error) {
      this.setState({
        ...this.state,
        formError: error,
        submitting: false
      });
    }
  };

  eventHasPassed = (eventDate, comparedDate) => {
    const duration = dateTimeutils.compareDate(eventDate, comparedDate);
    return duration;
  };

  fetchData = () => {
    const { pageNum, pageSize, filterParams } = this.state;
    let params = { pageNum: pageNum + 1, pageSize };
    if (filterParams) {
      params = { ...filterParams, ...params };
    }
    this.getEvents(params);
  };

  setPageNumber = pageIndex => {
    this.setState({ pageNum: pageIndex }, () => this.fetchData());
  };

  setPageSize = (pageSize, pageIndex) => {
    this.setState({ pageSize, pageNum: pageIndex }, () => this.fetchData());
  };

  filterData = params => {
    this.setState({ filterParams: params, pageNum: 0 }, () => this.fetchData());
  };

  selectRow = (selectedRow, action) => {
    this.setState({
      selectedRow: selectedRow.original,
      hasParams: true,
      isView: action === "view" ? true : false
    });
  };

  resetButton = () => {
    this.setState({
      hasParams: false,
      submitting: false,
      selectedRow: null,
      submitted: false,
      isView: false
    });
  };

  showConfirmation = selectedRow => {
    this.setState({
      selectedRow: selectedRow.original,
      showModal: !this.state.showModal
    });
  };

  deleteEvent = async item => {
    this.setState({
      ...this.state,
      deletingEvent: true,
      deleteError: null,
      deleteResponse: null
    });
    try {
      const deleteResponse = await eventService.deleteEvent(item.id);
      if (deleteResponse) {
        this.setState({
          deletingEvent: false,
          deletedEvent: true,
          deleteError: null,
          deleteResponse,
          showModal: false
        });
        this.fetchData();
        toast.success("Event cancelled successfully", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 4000
        });
      }
    } catch (error) {
      this.setState({
        deletingEvent: false,
        deletedEvent: false,
        deleteError: error,
        deleteResponse: null
      });
    }
  };
  //===========================TOUR GUIDE SECTION==================//
  setNextJoyRide = () => {
    this.setState({ showNextJoyRide: false });
  };

  startJoyRideAtDataTable = () => {
    this.setState({ showJoyRideOnTable: true });
  };

  stopJoyRideAtDataTable = () => {
    this.setState({ showJoyRideOnTable: false });
  };

  routeChange = () => {
    this.props.history.push({
      pathname: `/instructors`,
      state: { run: true }
    });
  };
  render() {
    const {
      fetching,
      fetched,
      events,
      pages,
      pageNum,
      pageSize,
      error,
      submitting,
      submitted,
      hasParams,
      selectedRow,
      formError,
      deletingEvent,
      deletedEvent,
      deleteError,
      deleteResponse,
      isView,
      showNextJoyRide,
      showJoyRideOnTable
    } = this.state;

    return (
      <Row>
        <Col sm="4">
          <EventForm
            submitting={submitting}
            error={formError}
            hasParams={hasParams}
            selectedRow={selectedRow}
            submitAction={this.addEvent}
            reset={this.resetButton}
            submitted={submitted}
            isView={isView}
            showNextJoyRide={showNextJoyRide}
            setNextJoyRide={this.setNextJoyRide}
            startJoyRideAtDataTable={this.startJoyRideAtDataTable}
          />
        </Col>
        <Col sm="8">
          <EventTable
            fetching={fetching}
            fetched={fetched}
            data={events}
            pages={pages}
            page={pageNum}
            pageSize={pageSize}
            error={error}
            filterData={this.filterData}
            DeleteModal={this.DeleteModal}
            deleteCategory={this.deleteCategory}
            showModal={this.showConfirmation}
            setPageNumber={this.setPageNumber}
            setPageSize={this.setPageSize}
            selectRow={this.selectRow}
            routeChange={this.routeChange}
            showJoyRideOnTable={showJoyRideOnTable}
            stopJoyRideAtDataTable={this.stopJoyRideAtDataTable}
          />
        </Col>
        <ConfirmationModal
          isOpen={this.state.showModal}
          showModal={this.showConfirmation}
          action={this.deleteEvent}
          actionState={{
            sending: deletingEvent,
            sent: deletedEvent,
            error: deleteError,
            response: deleteResponse
          }}
          item={selectedRow}
        />
      </Row>
    );
  }
}

export default ManageEvents;
